import { getFormData } from 'core/utils';

import { mapRecordFromServer, mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, GetOneResponse, IOption, IRequestPayload } from 'coreOld/types';
import {
  getQueryString,
  objectKeysCamelToSnakeCase,
  objectKeysSnakeCaseToCamelCase,
} from 'coreOld/utils';
import { IRequest, IRequestType, ISupportRequestPayload } from 'support/types';

export const getOne = async (
  requestPayload: ISupportRequestPayload,
  signal: AbortSignal
): Promise<GetOneResponse<IRequest>> => {
  const { data } = await partfinitiClient.get(
    `/support/request-list/requests?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordFromServer<IRequest>(data.data?.[0]);
};

export const getMany = async (
  requestPayload: IRequestPayload
): Promise<GetManyResponse<IRequest>> => {
  const { data } = await partfinitiClient.get(
    `/support/request-list/requests?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`
  );

  return mapRecordsFromServer<IRequest>(data.data, data.recordsFiltered);
};

export const getRequestTypeList = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IRequestType>> => {
  const { data } = await partfinitiClient.get('/support/request-type-list/request-types', signal);

  return mapRecordsFromServer<IRequestType>(data.data, data.recordsFiltered);
};

export const getTypes = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/support/request-type-list/request-types', signal);

  return mapRecordsFromServer<IRequestType>(data.data, data.recordsFiltered);
};

export const getStatuses = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/support/request-status-list/statuses', signal);

  return mapRecordsFromServer<IOption>(data.data, data.recordsFiltered);
};

export const upsertRequest = async (data: IRequest) => {
  const dataToSend = getFormData(data, true);

  const result = await partfinitiClient.post('/support/request-edit/save', dataToSend);

  return objectKeysSnakeCaseToCamelCase(result.data);
};

export const upsertRequests = async (data: IRequest) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/support/request-edit/save-bulk', dataToSend);

  return objectKeysSnakeCaseToCamelCase(result.data);
};
